// Единственное место, где задан адрес инструкции по настройке. Статья общая для
// amoCRM и Bitrix24 и покрывает весь путь: требования, регистрация, привязка
// платформы, справочники, сценарий, тест, статусы журнала.
export const SETUP_GUIDE_URL = 'https://help.fintablo.ru/article/30329'

// Подпись называет назначение, а не «здесь»: она же служит доступным именем
// ссылки там, где на узком экране остаётся только иконка.
export const SETUP_GUIDE_LABEL = 'Инструкция по настройке'
